import './App.css';
import React from 'react';
import Home from './components/Home';
import Opening from './components/Opening';
import Work from './components/Work';
import Contact from './components/Contact';

import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";

function App() 
{
  return (
    <>
    <div>
     <Router>
     <Routes>
         <Route exact path="/" element={<Opening/>}/>
          <Route path="/home" element={<Home/>}/>
          <Route path="/work" element={<Work/>}/>
          <Route path="/contact" element={<Contact/>}/>
      </Routes>
      </Router>
    </div>
    </>
  );
}

export default App;
